import $api from "@/frontend/shared/api/axios";

export function unarchiveCompany(ids: number[]) {
  return $api.post(`/portfolio-companies/unarchive/bulk`, {
    portfolioCompanyIds: ids
  });
}
